
import React from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Row, Col } from "antd";
import moment from 'moment';
import { displayPan, } from "../../../../../helpers/utilities";
import { SalesLines } from "./inc/Components";
import FileUpload from "../../FileUpload";


export const Format2 = React.forwardRef((props, ref) => {
    const { details, preview, sAddress, proformaPreview, businessDetails, count } = props;
    const classes = customStyles();

    let placeOfSupply = !preview ? sAddress.split("@@@") : '';

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    const addressShipped = (sAddress) => {
        if (!preview) {
            let sKey = sAddress.split("@@@");
            let address = sKey[0] || '';
            address += address !== '' ? ', ' : '';
            address += sKey[1] || '';
            return address;
        } else {
            return false;
        }
    }

    const address1Shipped = (sAddress) => {
        if (!preview) {
            let sKey = sAddress.split("@@@");
            let address = sKey[2] ? sKey[2] + ' - ' : '---';
            address += sKey[3] ? sKey[3] : '---';
            address += sKey[4] ? ', ' + sKey[4] : '---';
            address += sKey[5] ? ', ' + sKey[5] : '---';
            return address;
        } else {
            return false;
        }
    }

    return (
        <div className={classes.printFullPage}>
            {count > 1 ? <div className="page-break"></div> : ''}
            <div className={classes.downloadbars}>
                <div className={classes.downloadtopbar}></div>
                {
                    proformaPreview ? <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.downloadsecondbar}>Draft</div> :
                        <div className={classes.downloadsecondbar}> Sales Order
                            {
                                details?.OrderStatus === 'CANCELLED' ? ' - Cancelled' : ''
                            }</div>
                }
            </div>
            <div className={classes.downloaddetails}>
                <Row>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.billtoppadding, classes.billCustom)}>
                        <Row type="flex" gutter={15}>
                            {
                                (businessDetails?.logoUri || details?.logoUri) &&
                                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} className={classes.dispalyIF}>
                                    <div className={clsx(classes.productImageUpload, classes.dropDown)}>
                                        <FileUpload filePath={details?.business?.logoUri || businessDetails?.logoUri || ''} view={true} />
                                    </div>
                                </Col>
                            }
                            <Col xxl={details?.business?.logoUri || businessDetails?.logoUri ? 10 : 15}
                                xl={details?.business?.logoUri || businessDetails?.logoUri ? 10 : 15}
                                lg={details?.business?.logoUri || businessDetails?.logoUri ? 10 : 15}
                                md={details?.business?.logoUri || businessDetails?.logoUri ? 10 : 15}
                                sm={details?.business?.logoUri || businessDetails?.logoUri ? 10 : 15}
                                xs={details?.business?.logoUri || businessDetails?.logoUri ? 10 : 15}>
                                <h1>{details?.business?.name || businessDetails?.businessName || '---'}</h1>
                                <div className={classes.bill}>
                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(businessDetails || details?.business)}</p>
                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(businessDetails || details?.business)}</p>
                                </div>
                                <Row className={clsx(classes.bill, classes.margin30t)}>
                                    <Col span={24}>
                                        <Row>
                                            <Col span={3}>
                                                <h6>Email</h6>
                                            </Col>
                                            <Col span={21}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.email || details?.business?.email || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={6}>
                                                <h6>Ph No.</h6>
                                            </Col>
                                            <Col span={18}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.mobile || details?.business?.mobile || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    {
                                        (businessDetails?.pan || details?.business?.panNumber) && <Col span={24}>
                                            <Row>
                                                <Col span={3}>
                                                    <h6>{displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}</h6>
                                                </Col>
                                                <Col span={21}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </Col>
                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} className={clsx(classes.bill)}>
                                <h6>Order Number</h6>
                                <h1>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.serialNo || '---'}</h1>
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} className={clsx(classes.bill, classes.textAlignRight)}>
                                <h6>Created By</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.createdBy || '---'}</p>
                                <h6 className={classes.margin10t}>Date</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : (details?.transactionDate ? moment(details?.transactionDate).format('DD MMM YYYY') : '---') || '---'}</p>
                                <h6 className={classes.margin20t}>Delivery Date</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : (details?.deliveryDate ? moment(details?.deliveryDate).format('DD MMM YYYY') : '---') || '---'}</p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className={clsx(classes.yellowBorderTop)}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.borderRight, classes.bill, classes.billtoppadding)}>
                        <h6>Bill To</h6>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.customer?.name || '---'}</p>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details?.customer)}</p>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details?.customer)}</p>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.bill, classes.billtoppadding)}>
                        <h6>Shipped To</h6>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.name || '---'}</p>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : addressShipped(sAddress)}</p>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1Shipped(sAddress)}</p>
                    </Col>
                </Row>
                <Row>
                    <Col span={12} className={clsx(classes.borderRight, classes.bill, classes.billbottompadding)}>
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col span={3}>
                                        <h6>Email</h6>
                                    </Col>
                                    <Col span={21}>
                                        <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.email || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row>
                                    <Col span={6}>
                                        <h6>Ph No.</h6>
                                    </Col>
                                    <Col span={18}>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.mobile || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>

                            {
                                details?.customer?.pan && <Col span={24}>
                                    <Row>
                                        <Col span={3}>
                                            <h6>{displayPan(details?.pan)[0]}</h6>
                                        </Col>
                                        <Col span={21}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.customer?.pan)[1]}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row>
                    </Col>
                    <Col span={12} className={clsx(classes.bill, classes.billbottompadding)}>
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col span={3}>
                                        <h6>Email</h6>
                                    </Col>
                                    <Col span={21}>
                                        <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.email || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row>
                                    <Col span={6}>
                                        <h6>Ph No.</h6>
                                    </Col>
                                    <Col span={18}>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.phone || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            {
                                details?.customer?.pan && <Col span={24}>
                                    <Row>
                                        <Col span={3}>
                                            <h6>{displayPan(details?.pan)[0]}</h6>
                                        </Col>
                                        <Col span={21}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.customer?.pan)[1]}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row>
                    </Col>
                </Row>
                <Row className={clsx(classes.secondSection, classes.yellowBorderTop)}>
                    <Col span={details?.reference ? 8 : 16} className={clsx(classes.bill)} style={{ padding: "10px 15px 3px 15px" }}>
                        <div style={{ display: "flex" }}>
                            <h6 style={{ fontSize: "14px" }}>Place of Supply</h6>
                            <p style={{ paddingLeft: "10px", fontSize: "14px" }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : placeOfSupply[4]}</p>
                        </div>
                    </Col>
                    {
                        details?.reference && <Col span={8} className={clsx(classes.borderLeft, classes.bill)} style={{ padding: "10px 15px 3px 15px" }}>
                            <div style={{ display: "flex" }}>
                                <h6 style={{ fontSize: "14px" }}>Reference </h6>
                                <p style={{ paddingLeft: "10px", fontSize: "14px" }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.reference || '---'}</p>
                            </div>
                        </Col>
                    }
                </Row>
                <div className={clsx(classes.yellowBorderTop)}>
                    <div className={clsx(classes.thirdSection)}><SalesLines ref={ref} {...props} terms={true} /></div>
                </div>
            </div>
        </div>
    )
})